// import Router from 'vue-router'
import Login from '../pages/login/Login.vue'
import Nav from '../pages/nav/Nav.vue'
import Home from '../pages/home/Home'
import Activity from '../pages/activity/Activity.vue'
import GoodDetail from '../pages/good/Detail.vue'
import Cat from '../pages/cat/Cat'
import Order from '../pages/my/Order.vue'
import OrderMb from '../pages/my/OrderMb.vue'
import Cart from '../pages/cart/Cart.vue'
import DetailMb from '../pages/good/DetailMb'
import Search from '../pages/home/Search'
import Countdown from '@/pages/home/Countdown.vue'
import End from '@/pages/home/End.vue'
import OrderDetail from '@/components/order/OrderDetail.vue'
import PayMoney from '@/components/pay/PayMoney.vue'
import CartMb from '../pages/cart/CartMb.vue'
// Vue.use(Router)

export default [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/campaigns',
    component: Activity,
  },
  {
    path: '/detailMb',
    name: 'detailMb',
    component: DetailMb,
  },
  {
    path: '/search',
    name: 'searchMb',
    component: Search,
  },
  {
    path: '/orderDetailMb/:orderId',
    component: OrderDetail
  },
  {
    path: '/countdown',
    name: 'countdown',
    component: Countdown,
  },
  {
    path: '/end',
    name: 'end',
    component: End,
  },
  {
    path: '/',
    component: Nav,
    redirect:'/campaigns',
    meta: {
      keepAlive: true,
    },
    children:[
      {
        path: 'home/:id',
        name: 'home',
        component: Home,
        meta: {
          keepAlive: true,
        }
      }, {
        path: '/cat',
        name: 'cat',
        component: Cat,
      },{
        path: 'homeFilter',
        component: Home,
      }, {
        path: 'goodDetail',
        name: 'goodDetail',
        component: GoodDetail,
      }, {
        path: 'order',
        component: Order,
      }, {
        path: 'orderMb/:orderType',
        component: OrderMb
      }, {
        path: 'orderDetail/:orderId',
        name: 'orderDetail',
        component: OrderDetail
      }, {
        path: 'pay/:orderId',
        component: PayMoney
      }, {
        path: 'cart',
        name: 'cart',
        component: Cart,
      }, {
        path: 'cartmb',
        name: 'cartmb',
        component: CartMb,
      }
    ]
  },
  {
    path: '*',
    redirect: {
      path: '/campaigns'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/index.js